import { useCallback, useEffect, useState } from "react";
import TabHeader from "../../general-ui/tab-header/tab-header";
import ButtonPlain from "../../general-ui/button-plain/button-plain";
import { COLORS, ICONS } from "../../general-ui/icon";
import "./settings-main.scss";
import SettingsChannel from "./settings-channel";
import SettingsAdmins, { SettingsAdminsOverview } from "./settings-admins";
// Subscription Tab will be a future implementation
// import SettingsSubscription from "./settings-subscription";
// import SettingsIntegrations from "./settings-integrations";
import { useHistory, useParams } from "react-router";
import { PATHNAMES } from "../admin";
import { capitalize } from "../../../utils/utils";
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import { useDispatch } from 'react-redux';
import { getAdmins } from '../../../store/actions/admin/bl-admin';
import SettingsIntegrations from "./settings-integrations";

export default function SettingsMain(): JSX.Element {
	const { token } = useTypedSelector(state => state.AuthReducer);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getAdmins(token!));
	}, [token, dispatch]);

	//get tab name from incoming route
	const { tab }: { tab?: string; } = useParams();

	//lets us manipluate the route
	const history = useHistory();

	const [editChannel, setEditChannel] = useState(false);

	const closeModal = useCallback(() => {
		setEditChannel(false);
	}, []);

	const settingsTabs: {
		name: string;
		title?: string;
		overviewButton: { icon: string, text: string, iconAfter: boolean; };
		overviewContent: JSX.Element;
		tabContent?: JSX.Element;
	}[] =
		[
			{
				name: "Overview",
				title: "Channel Name",
				overviewButton: { icon: ICONS.EDIT, text: "Edit", iconAfter: false },
				overviewContent: <SettingsChannel openModal={editChannel} closeModal={closeModal} />,
			},
			{
				name: "Admins",
				overviewButton: { icon: ICONS.ARROW_RIGHT, text: "View more", iconAfter: true },
				overviewContent: <SettingsAdminsOverview />,
				tabContent: <SettingsAdmins />,
			},
			// FUTURE DEV - this feature will be a future implementation
			// {
			// 	name: "Subscription",
			// 	overviewButton: { icon: ICONS.ARROW_RIGHT, text: "View all plans", iconAfter: true },
			// 	overviewContent: <SettingsSubscription />,
			// 	tabContent: <SettingsSubscription />,
			// },
			// FUTURE DEV - this feature will be a future implementation
			{
				name: "Integrations",
				overviewButton: { icon: ICONS.ARROW_RIGHT, text: "Manage integrations", iconAfter: true },
				// Eventually we should only show the limited list on the overview page but showing all for now
				overviewContent: <SettingsIntegrations />,
				// overviewContent: <SettingsIntegrations overview />,
				tabContent: <SettingsIntegrations />,
			},
		];

	//if the user has directly entered a route, start with that route, default to Overview if they didn't go to a specific tab
	const [activeTab, setActiveTab] = useState(tab ? capitalize(tab) : settingsTabs[0].name);

	const handleButtonClick = (buttonID: string): void => {
		buttonID === settingsTabs[0].name ? setEditChannel(true) : setActiveTab(buttonID);
	};

	//when the active tab changes, update the current route path
	useEffect(() => {
		history.replace(`${PATHNAMES.SettingsLink}/${activeTab.toLowerCase()}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab]);

	return (
		<main className="settings-main wrapper">
			<div className="settings-container">
				<h2>Settings</h2>
				<div className="tab-wrapper">
					<div className="tab-container">
						<div className="tab-header">
							<TabHeader
								tabs={settingsTabs.map((tab) => tab.name)}
								onClick={setActiveTab}
								currentTab={activeTab}
							/>
						</div>
					</div>
				</div>
				{activeTab === settingsTabs[0].name ? (
					<>
						{settingsTabs.map((tab) => (
							<article key={tab.name} className="settings-card-container">
								<div className="settings-card">
									<div className="settings-card-header">
										<h6>{tab.title || tab.name}</h6>
										<ButtonPlain
											icon={tab.overviewButton.icon}
											iconSize={12}
											iconAfterText={tab.overviewButton.iconAfter}
											color="white"
											style={{ color: COLORS.WHITE }}
											onclick={() => handleButtonClick(tab.name)}
										>
											{tab.overviewButton.text}
										</ButtonPlain>
									</div>
									<div className="settings-card-body">
										{tab.overviewContent}
									</div>
								</div>
							</article>
						))}
					</>
				) : (
					settingsTabs.find((tab) => tab.name === activeTab)?.tabContent
				)}
			</div>
		</main>
	);
}
